'use strict';

module.exports = {
  BOX: 'box'
};


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-custom/ItemTypes.js
 ** module id = 69
 ** module chunks = 0
 **/